import { render, staticRenderFns } from "./kalemdiger.vue?vue&type=template&id=d8242e30&"
import script from "./kalemdiger.vue?vue&type=script&lang=js&"
export * from "./kalemdiger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports